"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID_KEYWORD_VALUE_MAP = exports.GRID_TEMPLATE_KEYWORD_VALUE_MAP = exports.FLEX_KEYWORD_VALUE_MAP = exports.EDGE_SHORTHAND_INDICES_BY_LENGTH = exports.CORNER_SHORTHAND_CORNERS = exports.EDGE_SHORTHAND_EDGES = exports.CSS_PROPERTY_DELIMITER = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../css-data-types");
exports.CSS_PROPERTY_DELIMITER = '-';
exports.EDGE_SHORTHAND_EDGES = ['top', 'right', 'bottom', 'left'];
exports.CORNER_SHORTHAND_CORNERS = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
exports.EDGE_SHORTHAND_INDICES_BY_LENGTH = [
    [0, 0, 0, 0],
    [0, 1, 0, 1],
    [0, 1, 2, 1],
    [0, 1, 2, 3],
];
exports.FLEX_KEYWORD_VALUE_MAP = {
    initial: {
        'flex-grow': css_data_types_1.INITIAL_FLEX_GROW,
        'flex-shrink': css_data_types_1.INITIAL_FLEX_SHRINK,
        'flex-basis': css_data_types_1.AUTO_FLEX_BASIS,
    },
    auto: {
        'flex-grow': css_data_types_1.AUTO_FLEX_GROW,
        'flex-shrink': css_data_types_1.INITIAL_FLEX_SHRINK,
        'flex-basis': css_data_types_1.AUTO_FLEX_BASIS,
    },
    none: {
        'flex-grow': css_data_types_1.INITIAL_FLEX_GROW,
        'flex-shrink': css_data_types_1.NONE_FLEX_SHRINK,
        'flex-basis': css_data_types_1.AUTO_FLEX_BASIS,
    },
};
exports.GRID_TEMPLATE_KEYWORD_VALUE_MAP = {
    none: {
        'grid-template-areas': css_data_types_1.INITIAL_GRID_TEMPLATE_AREAS,
        'grid-template-rows': css_data_types_1.INITIAL_GRID_TEMPLATE_AXIS,
        'grid-template-columns': css_data_types_1.INITIAL_GRID_TEMPLATE_AXIS,
    },
};
exports.GRID_KEYWORD_VALUE_MAP = {
    none: tslib_1.__assign(tslib_1.__assign({}, exports.GRID_TEMPLATE_KEYWORD_VALUE_MAP.none), { 'grid-auto-flow': css_data_types_1.INITIAL_GRID_AUTO_FLOW, 'grid-auto-rows': css_data_types_1.INITIAL_GRID_AUTO_AXIS, 'grid-auto-columns': css_data_types_1.INITIAL_GRID_AUTO_AXIS }),
};
//# sourceMappingURL=shorthand-css-data.js.map